<template>
  <div class="fixed-header mx-5 mt-3 ">
    <v-container fluid class="pa-0 info-drawer">
      <v-row>
        <v-col cols="10">
          <h2>Modify Permission</h2>
        </v-col>
        <v-col cols="2" class="d-flex justify-end pr-0">
          <v-btn
            id="close-drawer-btn"
            class="text-right"
            icon
            @click.stop="closeDrawer()"
            v-track="'close-permissions-drawer'"
          >
            <v-icon medium>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <h5 class="mt-6 mb-2 text-uppercase font-weight-bold">
        User Information
      </h5>
      <p class="mt-0 mb-8 text--disabled">{{drawerData.email}}</p>
      <v-divider></v-divider>
      <h5 class="mt-6 mb-4 text-uppercase font-weight-bold">User Access</h5>
      <v-select
        class="mt-2 mb-8 text-capitalize"
        color="mpBlue"
        v-model="permissionType"
        :items="permissionTypes"
        label="Permission Type"
        item-text="name"
        item-value="value"
        solo
        v-track="'set-user-access-type'"
      ></v-select>
      <v-divider></v-divider>
      <v-row class="my-8 mx-0">
        <v-btn class="mr-4 font-weight-bold" text @click="closeDrawer" v-track="'cancel-permission-changes'">Cancel</v-btn>
        <v-btn dark @click="onPermissionChange" v-track="'apply-permission-changes'">Done</v-btn>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
const PERMISSIONS = {
  'viewer': {name:"Viewer",value:"viewer"},
  'editor': { name: "Editor", value: "editor" }
};
export default {
  name: "ModifyPermissionsDrawer",
  data() {
    return {
      permissionTypes: Object.values(PERMISSIONS),
      permissionType:"",
    };
},
computed:{
    ...mapGetters({
        drawer: "ui/drawer"
    }),
    drawerData(){
        return this.drawer.right.payload
    },
  },
  mounted(){
    this.setPermissionType()
  },
  methods: {
    ...mapMutations({
      drawerHandler: "ui/drawer.right",
    }),
    closeDrawer(){
      this.drawerHandler({
        show: false,
        component: "modify-permissions-drawer"
      })
    },
    onPermissionChange(){
        this.$root.$emit('permissionchange', {id:this.drawerData.id, permission_type:this.permissionType});
        this.closeDrawer();
    },
    setPermissionType() {
      const { permission_type } = this.drawer.right.payload;
      this.permissionType = (permission_type === PERMISSIONS.editor.value) ? PERMISSIONS.editor.value : PERMISSIONS.viewer.value;
    }
  }
};
</script>
